export default {
  'navBar.home': 'Trang chủ',
  'navBar.features': 'Game',
  'navBar.myRequests': 'Theo dõi phiếu',
  'navBar.academy': 'Học viện',
  'navBar.signIn': 'Đăng nhập',
  'navBar.search': 'Tìm kiếm',
  'navBar.getStarted': 'Bắt đầu',
  'navBar.viewAll': 'Xem tất cả',
  'navBar.forgotPassword': 'Quên mật khẩu',
  
  // Get started section
  'navBar.getStarted.title': 'Bắt đầu',
  'navBar.getStarted.description': 'Tạo tài khoản Garena và thưởng thức những tựa game hấp dẫn',
  'navBar.getStarted.button': 'Tạo ngay'
}